import { useAppSelector } from "hooks/redux";
import React, { createContext, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";

type TDashboardContext = {
  selectedCourseIds: Array<number>;
  setSelectedCourseIds: React.Dispatch<React.SetStateAction<number[]>>;
  selectedDivisionIds: Array<number>;
  setSelectedDivisionIds: React.Dispatch<React.SetStateAction<number[]>>;
};

const defaultState: TDashboardContext = {
  selectedCourseIds: [],
  setSelectedCourseIds: null,
  selectedDivisionIds: [],
  setSelectedDivisionIds: null,
};

const CreateDashboardContext = createContext<TDashboardContext>(defaultState);
export const useDashboardContext = () => useContext(CreateDashboardContext);

export default function DashboardContext(props: { children: React.ReactNode }) {
  const [selectedCourseIds, setSelectedCourseIds] = useState<Array<number>>([]);
  const [selectedDivisionIds, setSelectedDivisionIds] = useState<Array<number>>([]);
  const { facilityStore } = useAppSelector(store => store);

  useEffect(() => {
    if (facilityStore?.facility?.courses) {
      const courseIds = facilityStore?.facility?.courses?.map(course => course?.id);
      const divisionIds = facilityStore?.facility?.courses
        ?.map(course => course?.divisions?.map(division => division?.id))
        ?.reduce((a, b) => a.concat(b, []), []);
      ReactDOM.unstable_batchedUpdates(() => {
        setSelectedCourseIds(courseIds);
        setSelectedDivisionIds(divisionIds);
      }, []);
    }
  }, [facilityStore?.facility]);

  return (
    <CreateDashboardContext.Provider
      value={{ selectedCourseIds, setSelectedCourseIds, selectedDivisionIds, setSelectedDivisionIds }}
    >
      {props.children}
    </CreateDashboardContext.Provider>
  );
}
